import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  InputGroup,
  InputGroupAddon,
  Row,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CustomInput
} from "reactstrap";

//Our Custom Components
import ScanbuyTable from "../../tables/ScanbuyTable";
import BatchFilterSelect from "../../elements/filters/BatchFilterSelect";
import GroupSelect from "../../elements/groups/GroupSelect";
import {useIntl} from "react-intl";
import {StateContext} from "../../../App";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSlidersH} from "@fortawesome/free-solid-svg-icons";
import {useRouterStore} from "mobx-state-router";
import { buildColumns } from "../../../pages/codes/batches/List";
import OptionalColumnsDropdown from "../../elements/dropdown/OptionalColumnsDropdown";

const buildColumnsWrapper = (routerStore, listViewState) => buildColumns(routerStore, listViewState.store, listViewState);

/**
 *
 * @param batchListState - BatchListState
 */
const BatchListView = observer(({ batchListState }) => {
  const intl = useIntl();
  const routerStore = useRouterStore();

  //TODO: PATTERN VIOLATION - setOnSelectChanges called on every render
  // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
  batchListState.setOnSelectChanges()
  console.log("BatchListView: batchListState: ", batchListState)
  // useEffect(() => {
  //   batchListState?.handleFilterChange({
  //     groupUuid: batchListState?.groupSelectStore?.selectedGroup?.uuid,
  //   })
  // }, [batchListState])
  useEffect(() => {
    batchListState.refresh()
  }, [batchListState])
  // batchListState.setOnSelectChanges();
  return (
    <Card>
      <CardBody>
        <Row className="mb-2">
          <Col className="d-flex justify-content-end">
            <OptionalColumnsDropdown
              listViewState={batchListState}
              buildColumnsFunction={buildColumnsWrapper}
              idPrefix="batch-col"
            />
          </Col>
        </Row>
        <Row>
          {/*TODO: need add group filter for batches*/}
          {/*<Col sm={4}>*/}
          {/*  <InputGroup className="mb-3">*/}
          {/*    <InputGroupAddon addonType="prepend">*/}
          {/*      {intl.formatMessage({ id: "filterByGroups.defaultMessage"})}*/}
          {/*    </InputGroupAddon>*/}
          {/*    <GroupSelect groupSelectStore={batchListState.groupSelectStore}/>*/}
          {/*  </InputGroup>*/}
          {/*</Col>*/}
          <Col sm={4}>
            <InputGroup className="mb-3">
              <InputGroupAddon addonType="prepend">
                Filter
              </InputGroupAddon>
              <BatchFilterSelect batchFilterSelectState={batchListState.batchFilterSelectState}/>
            </InputGroup>
          </Col>
        </Row>
        <ScanbuyTable
          key = {batchListState.columns.length}
          columns={batchListState.columns}
          customStyles={batchListState.customStyles}
          store={batchListState.store}
        />
      </CardBody>
    </Card>
  );
})

export default BatchListView;
